import { Component } from '@angular/core';

@Component({
  selector: 'app-confirmacion-cita',
  templateUrl: './confirmacion-cita.component.html',
  styleUrls: ['./confirmacion-cita.component.css']
})
export class ConfirmacionCitaComponent {

}
